/*
 * @Author: Musa Tabitay
 * @Date: 2019-12-31 00:21:23
 * @LastEditTime: 2022-04-10 21:25:46
 */

let envList = {
  development: { // 开发环境
    baseUrl: 'http://localhost:3069'
  },
  production: { // 测试环境
    baseUrl: 'https://alataw.suraq.net'
  }
}

// 每次手动修改项目环境变量
let baseUrl = envList[process.env.NODE_ENV].baseUrl

export default baseUrl



// WEBPACK FOOTER //
// ./src/util/index.js